var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCelebrationPopperIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6346 20.7109L3.66797 40.3276L23.2846 33.3793",
    stroke: "#5D5FEF",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 5.5H7.35037",
    stroke: "#5D5FEF",
    strokeOpacity: 0.26,
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.332 14.6641H40.3504",
    stroke: "#5D5FEF",
    strokeOpacity: 0.26,
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 3.66406H27.5183",
    stroke: "#5D5FEF",
    strokeOpacity: 0.26,
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.332 36.6641H40.3504",
    stroke: "#5D5FEF",
    strokeOpacity: 0.26,
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3346 3.66406L36.228 5.03906C35.059 5.42844 34.0616 6.21174 33.4061 7.25506C32.7507 8.29838 32.478 9.53695 32.6346 10.7591C32.818 12.3357 31.5896 13.7474 29.9763 13.7474H29.2796C27.703 13.7474 26.3463 14.8474 26.053 16.3874L25.668 18.3307",
    stroke: "#5D5FEF",
    strokeOpacity: 0.26,
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3346 23.8399L38.8313 23.2349C37.2546 22.6115 35.4946 23.6015 35.2013 25.2699C34.9996 26.5532 33.8813 27.5065 32.5796 27.5065H31.168",
    stroke: "#5D5FEF",
    strokeOpacity: 0.26,
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 3.66406L20.7717 5.1674C21.395 6.74406 20.405 8.50406 18.7367 8.7974C17.4533 8.98073 16.5 10.1174 16.5 11.4191V12.8307",
    stroke: "#5D5FEF",
    strokeOpacity: 0.26,
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1669 23.8271C23.7053 27.3654 25.3553 31.4721 23.8336 32.9938C22.3119 34.5154 18.2053 32.8654 14.6669 29.3271C11.1286 25.7888 9.47861 21.6821 11.0003 20.1604C12.5219 18.6388 16.6286 20.2888 20.1669 23.8271Z",
    stroke: "#5D5FEF",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrationPopperIcon);
export default __webpack_public_path__ + "static/media/CelebrationPopperIcon.c6431124dc10631e85726f7f4ffe0bc2.svg";
export { ForwardRef as ReactComponent };